import config from 'config';
import Logger from 'utils/logger';

const FacebookUtils = {
  shouldSkip() {
    return !config.FACEBOOK_APP_ID;
  },
  loadScript() {
    try {
      if (this.shouldSkip()) {
        Logger.log('Skipping Facebook SDK script load');
        return;
      }
      if (document.getElementById('facebook-jssdk')) return;

      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    } catch (e) {
      Logger.error(e);
    }
  },
  init() {
    try {
      if (this.shouldSkip()) {
        Logger.log('Skipping Facebook SDK initialization');
        return;
      }

      window?.FB?.init({
        appId: config.FACEBOOK_APP_ID,
        version: config.FACEBOOK_SDK_VERSION,
      });
    } catch (e) {
      Logger.error(e, 'Unable to init Facebook SDK');
    }
  },
  verifyScopes(
    grantedScopes: string | string[],
    requiredScopes: string | string[],
  ): boolean {
    const granted = Array.isArray(grantedScopes)
      ? grantedScopes
      : grantedScopes.split(',');
    const required = Array.isArray(requiredScopes)
      ? requiredScopes
      : requiredScopes.split(',');

    return required
      .map((scope) => granted.includes(scope))
      .every((isGranted) => isGranted);
  },
};

export default FacebookUtils;
